import cssMobile from '../../../css/editorMobile.module.css'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function TextControls({open, onBackClick}: ControlsProps) {
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      <div className={cssMobile.charCounterInputWrapper}>
        <input
          className={cssMobile.input}
          type="text"
          value={
            selectedImage?.type === 'caption' ? selectedImage.caption1 : ''
          }
          onChange={e => {
            if (selectedImage?.type === 'caption') {
              const trunctatedText = e.target.value
                .substring(0, 35)
                .replace(/[\u0400-\uF8FF]/g, '')
              if (trunctatedText.length <= 35) {
                handleUpdatedAttributes(dispatch, selectedImage, {
                  caption1: trunctatedText,
                })
              }
            }
          }}
        />
        <div className={cssMobile.charCounter}>
          {selectedImage?.type === 'caption'
            ? 35 - selectedImage.caption1.length
            : '-'}
          /35
        </div>
      </div>
      {selectedImage?.type === 'caption' && selectedImage.caption2 !== null && (
        <div className={cssMobile.charCounterInputWrapper}>
          <input
            className={cssMobile.input}
            type="text"
            value={selectedImage.caption2}
            onChange={e => {
              if (
                selectedImage?.type === 'caption' &&
                selectedImage.caption2 !== null
              ) {
                const trunctatedText = e.target.value
                  .substring(0, 35)
                  .replace(/[\u0400-\uF8FF]/g, '')
                if (trunctatedText.length <= 35) {
                  handleUpdatedAttributes(dispatch, selectedImage, {
                    caption2: trunctatedText,
                  })
                }
              }
            }}
          />
          <div className={cssMobile.charCounter}>
            {selectedImage?.type === 'caption'
              ? 35 - selectedImage.caption2.length
              : '-'}
            /35
          </div>
        </div>
      )}
    </ControlsBase>
  )
}
